module.exports = __webpack_public_path__ + "static/img/paiduitongzhi.c2873fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/paiduitongzhi.png
// module id = 70qr
// module chunks = 24